module.exports = __webpack_public_path__ + "static/media/boobs_v2.f27958e9.jpg";